var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.4994L11.5 14.4994L15.5 10.4994M21.118 6.48336C17.9561 6.65127 14.8567 5.55797 12.5 3.44336C10.1433 5.55797 7.0439 6.65127 3.882 6.48336C3.62754 7.46847 3.49918 8.48191 3.5 9.49936C3.5 15.0904 7.324 19.7894 12.5 21.1214C17.676 19.7894 21.5 15.0914 21.5 9.49936C21.5 8.45736 21.367 7.44736 21.118 6.48336Z",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeShield);
export default __webpack_public_path__ + "static/media/theme_shield.7e408953d24887fb2e3396525464d828.svg";
export { ForwardRef as ReactComponent };